import React, {useState} from "react";
import * as vkbeautify from "vkbeautify";

export const DownloadContext = React.createContext({
    content: "",
    payloadPath: "",
    preSignedUrl: "",
    contentType: "",
    contentEncoding: "",
    isDisplayed: false,
    previewLabelUrl: "",
    token: "",
    displayModal: (_content: string, _payloadPath: string, _preSignedUrl: string, _contentType: string, _contentEncoding: string, _previewLabelUrl: string, _token: string) => {
    },
    onClose: () => {
    },
});

    export const DownloadContextProvider = (props) => {
    const [content, setContent] = useState("");
    const [payloadPath, setPayloadPath] = useState("");
    const [preSignedUrl, setPreSignedUrl] = useState("");
    const [contentType, setContentType] = useState("");
    const [contentEncoding, setContentEncoding] = useState("");
    const [isDisplayed, setIsDisplayed] = useState(false);
    const [previewLabelUrl, setPreviewLabelUrl] = useState("");
    const [token, setToken] = useState("");

    const displayHandler = (content: string, payloadPath: string, preSignedUrl: string, contentType: string, contentEncoding: string, previewLabelUrl: string, token: string) => {
        try {
            let formattedJson = vkbeautify.json(content, 2);
            setContent(formattedJson);
        } catch {
            setContent(content);
        }
        setPayloadPath(payloadPath);
        setPreSignedUrl(preSignedUrl);
        setContentType(contentType);
        setContentEncoding(contentEncoding);
        setIsDisplayed(true);
        setPreviewLabelUrl(previewLabelUrl)
        setToken(token)
    };

    const closeHandler = () => {
        setIsDisplayed(false);
    };

    return (
        <DownloadContext.Provider value={{
            content: content,
            payloadPath: payloadPath,
            preSignedUrl: preSignedUrl,
            contentType: contentType,
            contentEncoding: contentEncoding,
            isDisplayed,
            previewLabelUrl: previewLabelUrl,
            token: token,
            displayModal: displayHandler,
            onClose: closeHandler
        }}>
            {props.children}
        </DownloadContext.Provider>

    );
};

export default DownloadContext;
